import React, { useEffect, useState, useRef } from "react";
import {
  Box, Card, CardContent, Typography, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, TextField,
  Button, Stepper, Step, StepLabel, Paper, MenuItem, InputAdornment, Stack,
  Divider, CardHeader, Avatar, CircularProgress, Accordion, AccordionSummary, AccordionDetails,
  Switch, FormControlLabel
} from "@mui/material";
import { ArrowBack, ArrowForward, Remove, Add, Delete, CameraAlt } from "@mui/icons-material";
import LockOutlined from '@mui/icons-material/LockOutlined';
import LockOpenOutlined from '@mui/icons-material/LockOpenOutlined';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ArrowForwardIos, ArrowBackIosNew } from "@mui/icons-material";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { addDoc, collection, doc, getCountFromServer, getDoc, getDocs, onSnapshot, orderBy, query, serverTimestamp, Timestamp, updateDoc, where } from 'firebase/firestore';
import { db, storage } from "../../firebase";
import { addDays, format, differenceInDays, startOfDay, parseISO, eachDayOfInterval } from "date-fns";
import { motion, AnimatePresence } from "framer-motion";
import moment from "moment/moment";
import { getDownloadURL, ref, uploadString } from 'firebase/storage';
import Swal from 'sweetalert2';
import Webcam from "react-webcam";
import { useNavigate } from "react-router-dom";

const PAGE_SIZE = 7;
const LEFT_COL_WIDTH = 160;
const COL_WIDTH = 156;
const ROW_HEIGHT = 40;

const steps = ['Room Details', 'Customer Details', 'Document Section', 'Payment & Checkout'];
const today = new Date().toISOString().split('T')[0];
const DOCUMENT_TYPES = [
  { label: 'Aadhaar Card', value: 'aadhaar' },
  { label: 'PAN Card', value: 'pan' },
  { label: 'Driving License', value: 'dl' },
  { label: 'Voter ID', value: 'voter_id' },
  { label: 'Passport', value: 'passport' },
  { label: 'Other', value: 'other' }
];

const VALIDATION_RULES = {
  aadhaar: { pattern: /^\d{12}$/, message: 'Aadhaar must be 12 digits.', placeholder: '[Aadhaar Redacted]' },
  pan: { pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, message: 'Invalid PAN format.', placeholder: 'e.g. ABCDE1234F' },
  dl: { pattern: /^([A-Z]{2}[0-9]{2}[0-9]{11})$/, message: 'Invalid DL format.', placeholder: 'e.g. MH0120110001234' },
  voter_id: { pattern: /^[A-Z]{3}[0-9]{7}$/, message: 'Invalid Voter ID format.', placeholder: 'e.g. ABC1234567' },
  passport: { pattern: /^[A-PR-WYa-pr-wy][0-9]{7}$/, message: 'Invalid Passport format.', placeholder: 'e.g. A1234567' },
  other: { pattern: /^[a-zA-Z0-9\s\-/]{3,20}$/, message: 'Must be 3-20 alphanumeric characters.', placeholder: 'Enter Document ID' }
};

const colors = {
    darkGreen: '#06362D',
    calPolyGreen: '#155332',
    vanilla: '#DEE2B1',
    gold: '#FFD500',
    goldenrod: '#D1A505'
};

export default function Reserveroom() {
  const Toast = Swal.mixin({
    toast: true, position: 'top-end', showConfirmButton: false, timer: 3000, timerProgressBar: true
  });
  const navigate = useNavigate();
  const auth = getAuth();
  const webcamRef = useRef(null);

  const [propertyId, setPropertyId] = useState(null);
  const [propertyName, setPropertyName] = useState("Our Hotel");
  const [roomTypes, setRoomTypes] = useState([]);
  const [roomNumbers, setRoomNumbers] = useState({});
  const [reservations, setReservations] = useState([]);
  const [reservationMap, setReservationMap] = useState({});
  const [paymodes, setpaymodes] = useState([]);
  const [dates, setDates] = useState([]);
  const [page, setPage] = useState(0);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [bookingtypes, setbookingtypes] = useState([]);
  const [rooms, setrooms] = useState([]);
  const [plans, setplans] = useState([]);
  const [bookingrooms, setbookingrooms] = useState([]);
  const [activeStep, setActiveStep] = useState(0);

  // Form States
  const [checkindate, setcheckindate] = useState(moment().format('YYYY-MM-DD'));
  const [checkoutdate, setcheckoutdate] = useState(moment().add(1, 'days').format('YYYY-MM-DD'));
  const [noofdays, setnoofdays] = useState(1);
  const [checkintime, setcheckintime] = useState(moment().format('HH:mm A'));
  const [checkouttime, setcheckouttime] = useState('12:00 PM');
  const [adults, setadults] = useState(2);
  const [childs, setchilds] = useState(0);
  const [noofrooms, setnoofrooms] = useState(0);

  const [custname, setcustname] = useState("");
  const [mobile, setmobile] = useState("");
  const [email, setemail] = useState("");
  const [address, setaddress] = useState("");
  const [city, setcity] = useState("");
  const [state, setstate] = useState("Maharashtra");
  const [gender, setgender] = useState("Male");
  const [visitpurpose, setvisitpurpose] = useState("");
  const [companydetails, setcompanydetails] = useState("");
  const [gstname, setgstname] = useState("");
  const [gstno, setgstno] = useState("");
  const [bookingsource, setbookingsource] = useState("");
  const [bookingDate, setbookingDate] = useState(moment().format('YYYY-MM-DD'));

  const [documenttype, setdocumenttype] = useState("");
  const [idno, setidno] = useState("");
  const [otherDocumentType, setOtherDocumentType] = useState('');
  const [error, setError] = useState('');
  const [adultsList, setAdultsList] = useState([]);

  // Photos & Cameras
  const [activeCamera, setActiveCamera] = useState(null);
  const [photos, setPhotos] = useState({ visitor: '', idFront: '', idBack: '', couple: '' });
  const [photoUrls, setPhotoUrls] = useState({ visitorUrl: '', idFrontUrl: '', idBackUrl: '', coupleUrl: '' });
  const [uploadingState, setUploadingState] = useState({ visitor: false, idFront: false, idBack: false, couple: false });

  // Payment States
  const [paymode1, setpaymode1] = useState("");
  const [amount1, setamount1] = useState(0);
  const [paytime1, setpaytime1] = useState("");
  const [paymode2, setpaymode2] = useState("");
  const [amount2, setamount2] = useState(0);
  const [paytime2, setpaytime2] = useState("");
  const [rooamount, setrooamount] = useState(0);
  const [totalamount, settotalamount] = useState(0);
  const [advance, setadvance] = useState(0);
  const [remaining, setremaining] = useState(0);
  const [roundoff, setroundoff] = useState(0);
  const [note, setnote] = useState("");

  // Room Picker States
  const [rtypeid, setrtypeid] = useState("");
  const [roomid, setroomid] = useState("");
  const [planid, setplanid] = useState("");
  const [amount, setamount] = useState(0);
  const [discountupto, setdiscountupto] = useState(0);
  const [discount, setdiscount] = useState(0);
  const [discountError, setDiscountError] = useState("");
  const [roomrate, setroomrate] = useState(0);
  const [isAmountUnlocked, setIsAmountUnlocked] = useState(false);
  
  // New States for dynamic accordion control
  const [expanded, setExpanded] = useState(false);
  const [expandAll, setExpandAll] = useState(false);

  useEffect(() => {
    const arr = [];
    for (let i = 0; i < 180; i++) arr.push(startOfDay(addDays(new Date(), i)));
    setDates(arr);
  }, []);

  useEffect(() => {
    return onAuthStateChanged(auth, async (user) => {
      if (!user) return;
      const snap = await getDocs(collection(db, "authroles"));
      snap.forEach((d) => { if (d.id === user.uid) setPropertyId(d.data().propertyId); });
    });
  }, [auth]);

  useEffect(() => {
    if (propertyId) {
      loadRooms();
      loadReservations();
      fetchData1();
      fetchPropertyName();
    }
  }, [propertyId]);

  useEffect(() => {
    if (roomTypes?.length > 0 && !expanded && !expandAll) {
      setExpanded(roomTypes[0].id);
    }
  }, [roomTypes, expandAll]);

  const fetchPropertyName = async () => {
    try {
      const docRef = doc(db, "properties", propertyId);
      const snap = await getDoc(docRef);
      if (snap.exists()) setPropertyName(snap.data().hotelname );
      
    } catch (e) {
      console.log("Error fetching property name:", e);
    }
  };

  const loadRooms = async () => {
    const roomsSnap = await getDocs(query(collection(db, "rooms"), where("propertyId", "==", propertyId)));
    setRoomTypes(roomsSnap.docs.map(d => ({ id: d.id, ...d.data() })));

    const infoSnap = await getDocs(query(collection(db, "roominfos"), where("propertyId", "==", propertyId)));
    const map = {};
    infoSnap.docs.forEach(d => {
      const { roomTypeId, roomNo } = d.data();
      if (!map[roomTypeId]) map[roomTypeId] = [];
      map[roomTypeId].push({ id: d.id, roomNo: roomNo, data: d.data() });
    });
    setRoomNumbers(map);
  };

  const buildReservationMap = (reservationsData) => {
    const map = {};
    reservationsData.forEach(r => {
      const checkin = new Date(r.checkindate);
      const checkout = new Date(r.checkoutdate);
      r.rooms?.forEach(room => {
        eachDayOfInterval({ start: checkin, end: new Date(checkout.getTime() - 86400000) }).forEach(day => {
          map[`${room.roomno}_${format(day, "yyyy-MM-dd")}`] = r;
        });
      });
    });
    return map;
  };

  const loadReservations = async () => {
    const q = query(collection(db, "reservations"), where("propertyId", "==", propertyId), where("status", "==", "Booked"));
    const snap = await getDocs(q);
    const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    setReservations(data);
    setReservationMap(buildReservationMap(data));
  };

  const fetchData1 = async () => {
    try {
      onSnapshot(query(collection(db, 'paymentmodes'), where('propertyId', '==', propertyId), orderBy('createdAt', 'asc')), (snap) => {
        if (snap.docs.length > 0) {
          setpaymode1(snap.docs[0].id);
          setpaymode2(snap.docs[0].id);
        }
        setpaymodes(snap.docs.map(doc => ({ id: doc.id, data: doc.data() })));
      });
      onSnapshot(query(collection(db, 'bookingtypes'), where('propertyId', '==', propertyId), orderBy('createdAt', 'asc')), (snap) => {
        setbookingtypes(snap.docs.map(doc => ({ id: doc.id, data: doc.data() })));
      });
    } catch (error) {
      console.log(error);
    }
  };

  const visibleDates = Array.from({ length: PAGE_SIZE }, (_, i) => addDays(new Date(), page * PAGE_SIZE + i));
  const getReservationForCell = (roomNo, date) => reservationMap[`${roomNo}_${format(date, "yyyy-MM-dd")}`] || null;

  // STEP VALIDATION
  const handleNext = () => {
    if (activeStep === 0) {
      if (bookingrooms.length === 0) return Toast.fire({ icon: "error", title: "Please add at least one room." });
      if (!checkindate || !checkoutdate) return Toast.fire({ icon: "error", title: "Please select valid dates." });
    }
    if (activeStep === 1) {
      if (!custname.trim() || !mobile.trim() || !address.trim() || !city.trim()) {
        return Toast.fire({ icon: "error", title: "Please fill all required customer fields." });
      }
      if (mobile.length < 10) return Toast.fire({ icon: "error", title: "Valid 10-digit mobile number required." });
      if (error) return Toast.fire({ icon: "error", title: "Please fix document ID validation errors." });
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => setActiveStep((prevActiveStep) => prevActiveStep - 1);

  // DATES & CALCULATIONS
  const handleDateChange = (date1, date2) => {
    if (date1 && date2) {
      const diffInDays = moment(date2).diff(moment(date1), 'days');
      const finalDays = diffInDays <= 0 ? 1 : diffInDays;
      setnoofdays(finalDays);
      calFinalTotal(finalDays, rooamount);
    }
  };
  
  const calFinalTotal = (days, roomamountxx) => {
    let total = parseFloat(days) * parseFloat(roomamountxx || 0);
    let roff = total.toFixed(2) - total.toFixed(0);
    setroundoff(roff.toFixed(2));
    settotalamount(total.toFixed(0));
    setremaining((total - parseFloat(advance || 0)).toFixed(0));
  };

  const handleroomtypeChange = (value) => {
    setrtypeid(value); setamount(0); setroomrate(0); setdiscount(0); setdiscountupto(0); setroomid("");
    onSnapshot(query(collection(db, 'roominfos'), where('roomTypeId', '==', value)), (snap) => setrooms(snap.docs.map(doc => ({ id: doc.id, data: doc.data() }))));
    onSnapshot(query(collection(db, 'roomrates'), where('roomId', '==', value)), (snap) => setplans(snap.docs.map(doc => ({ id: doc.id, data: doc.data() }))));
  };

  // AVAILABILITY FILTER LOGIC
  const getAvailableRooms = () => {
    if (!checkindate || !checkoutdate) return [];
    try {
      const inDate = parseISO(checkindate);
      const outDate = parseISO(checkoutdate);

      let daysToCheck = [];
      if (inDate < outDate) {
        daysToCheck = eachDayOfInterval({
          start: inDate,
          end: new Date(outDate.getTime() - 86400000)
        });
      } else {
        daysToCheck = [inDate];
      }

      return rooms.filter(room => {
        const roomNo = room.data.roomNo;
        const isBookedInDb = daysToCheck.some(day => !!reservationMap[`${roomNo}_${format(day, "yyyy-MM-dd")}`]);
        const isAlreadyAdded = bookingrooms.some(b => b.roomid === room.id);
        
        return !isBookedInDb && !isAlreadyAdded;
      });
    } catch (error) {
      return rooms; 
    }
  };

  const availableRooms = getAvailableRooms();

  const handleplanChange = async (planDocId) => {
    setplanid(planDocId); setDiscountError("");
    try {
      const snap = await getDoc(doc(db, "roomrates", planDocId));
      if (snap.exists()) {
        const data = snap.data();
        setamount(Number(data.rate || 0).toFixed(2));
        setroomrate(Number(data.rate || 0).toFixed(2));
        setdiscountupto(data.discount || 0);
      }
    } catch (e) { console.error(e); }
  };

  const handleRoomArray = () => {
    if (!roomid || !rtypeid || !planid || !amount || !roomrate) return Toast.fire({ icon: "error", title: "All room fields are required" });
    const matchedRoom = rooms.find(r => r.id === roomid);
    const matchedPlan = plans.find(p => p.id === planid);
    const newItem = {
      roomid, roomno: matchedRoom?.data?.roomNo || "", rtypeid, roomtypename: matchedRoom?.data?.roomTypeName || "",
      planid, planname: matchedPlan?.data?.planName || "", amount: Number(amount).toFixed(2),
      discount: Number(discount || 0), roomrate: Number(roomrate).toFixed(2),
    };
    const updatedRooms = [...bookingrooms, newItem];
    setbookingrooms(updatedRooms);
    setnoofrooms(updatedRooms.length);
    const totalRoomAmount = updatedRooms.reduce((sum, r) => sum + Number(r.roomrate || 0), 0);
    setrooamount(totalRoomAmount.toFixed(2));
    calFinalTotal(noofdays, totalRoomAmount);
    setrtypeid(""); setroomid(""); setplanid(""); setamount(""); setdiscount(""); setdiscountupto(0); setroomrate("");
  };

  const removeItem = (itemToRemove) => {
    const updatedItems = bookingrooms.filter((item) => item !== itemToRemove);
    setbookingrooms(updatedItems);
    setnoofrooms(updatedItems.length);
    const totalRoomAmount = updatedItems.reduce((sum, r) => sum + Number(r.roomrate || 0), 0);
    setrooamount(totalRoomAmount.toFixed(2));
    calFinalTotal(noofdays, totalRoomAmount);
  };

  const handleamount1 = (e) => {
    let val = parseFloat(e.target.value || 0);
    let adv = val + parseFloat(amount2 || 0);
    if (adv > totalamount) return Toast.fire({ icon: "error", title: `Max advance: ${totalamount}` });
    setamount1(val); setadvance(adv); setremaining((totalamount - adv).toFixed(2));
  };
  const handleamount2 = (e) => {
    let val = parseFloat(e.target.value || 0);
    let adv = parseFloat(amount1 || 0) + val;
    if (adv > totalamount) return Toast.fire({ icon: "error", title: `Max advance: ${totalamount}` });
    setamount2(val); setadvance(adv); setremaining((totalamount - adv).toFixed(2));
  };

  // CAMERA & UPLOADS
  const handleCapture = () => {
    if (!webcamRef.current) return;
    const imageSrc = webcamRef.current.getScreenshot();
    setPhotos(p => ({ ...p, [activeCamera]: imageSrc }));
    setActiveCamera(null); 
  };

  const uploadPhoto = async (type) => {
    if (!photos[type]) return;
    try {
      setUploadingState(s => ({ ...s, [type]: true }));
      const storageRef = ref(storage, `bookings/${Date.now()}_${type}.jpg`);
      await uploadString(storageRef, photos[type], 'data_url');
      const url = await getDownloadURL(storageRef);
      setPhotoUrls(u => ({ ...u, [`${type}Url`]: url }));
      Toast.fire({ icon: "success", title: `${type} uploaded` });
    } catch (err) {
      Toast.fire({ icon: "error", title: "Upload failed" });
    } finally {
      setUploadingState(s => ({ ...s, [type]: false }));
    }
  };

  // WHATSAPP API
  const sendWhatsAppMessage = async (customerName, propName, roomStr, totAmount, inDate, outDate, mob) => {
    const wabaid = "1264091500117064";
    const accesstoken = "EAAcHt0w4sPkBSKT54p1Lpz2Jly0a5vhY1ks0UYJvVXygq23kb1TdHWR6bUzOfADscZBmm9eQk6CDYis6MyY3cLlYJZBvFcrgEjq0P4aHBjT9ZAMrCK3hufE5oOFKtgHFfq3BnLcR5FCqugCJ4L6WcSpyAwoKQpz0KrLGdF3iOJt9DHOZATbI2lHnym5n8umjGQZDZD";
    const payload = {
      messaging_product: 'whatsapp',
      recipient_type: 'individual',
      to: '91' + mob,
      type: 'template',
      template: {
        name: 'checkin_confirmation',
        language: { code: 'en' },
        components: [{
          type: 'body',
          parameters: [
            { type: 'text', text: customerName || "Guest" },
            { type: 'text', text: propName  },
            { type: 'text', text: roomStr || "N/A" },
            { type: 'text', text: String(totAmount) },
            { type: 'text', text: inDate },
            { type: 'text', text: outDate },
          ],
        }],
      },
    };
    try {
      const response = await fetch(`https://graph.facebook.com/v20.0/${wabaid}/messages`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accesstoken}` },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        await addDoc(collection(db, 'whatsapphistory'), {
          custname: customerName, type: 'Checkin', mobile: mob, createdAt: Timestamp.now(), propertyId
        });
      }
    } catch (error) { console.error('Failed to send WhatsApp', error); }
  };

  // CHECKOUT & SAVE
  const safe = (obj) => Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== undefined));

  const checkoutReservation = async () => {
    try {
      setIsLoading(true);
      const customerData = {
        custname, mobile, email, address, city, state, gender, gstname, gstno, documenttype, otherDocumentType, idno,
        propertyId, uid: auth.currentUser?.uid, createdAt: Timestamp.now(),
      };
      const customerRef = await addDoc(collection(db, "customers"), customerData);

      const q = query(collection(db, "reservations"), where("propertyId", "==", propertyId));
      const bookingCountSnap = await getCountFromServer(q);
      const invoiceNo = bookingCountSnap.data().count + 1;

      const bookingPayload = safe({
        customerId: customerRef.id, invoiceno: invoiceNo, customers: customerData, rooms: bookingrooms, services: [],
        checkindate, checkoutdate, noofdays, checkintime, checkouttime, adults, childs, noofrooms: bookingrooms.length,
        visitpurpose, bookingsource,
        visitorPhotoUrl: photoUrls.visitorUrl, idFrontUrl: photoUrls.idFrontUrl,
        idBackUrl: photoUrls.idBackUrl, couplePhotoUrl: photoUrls.coupleUrl,
        rooamount: Number(rooamount), roundoff: Number(roundoff), totalamount: Number(totalamount),
        advance: Number(advance), remaining: Number(remaining), note, bookingDate, type: "GST", status: "Booked",
        approval1: "No", approval2: "No", approval3: "No", approval4: "No", damageamount: 0,
        propertyId, uid: auth.currentUser?.uid, additionalAdults: adultsList, createdAt: Timestamp.now(),
      });
      const bookingRef = await addDoc(collection(db, "reservations"), bookingPayload);

      for (let day = 0; day < noofdays; day++) {
        const inDate = moment(checkindate).add(day, "days").format("YYYY-MM-DD");
        const outDate = moment(checkindate).add(day + 1, "days").format("YYYY-MM-DD");
        for (const room of bookingrooms) {
          await addDoc(collection(db, "checkindetails"), safe({
            bookingid: bookingRef.id, customerId: customerRef.id, checkindate: inDate, checkoutdate: outDate,
            propertyId, roomid: room.roomid, roomtypeid: room.rtypeid, planid: room.planid, roomname: room.roomno,
            planname: room.planname, roomtype: room.roomtypename, status: "Booked", uid: auth.currentUser?.uid, createdAt: Timestamp.now(),
          }));
        }
      }

      if (Number(advance) > 0) {
        for (let i = 0; i < noofdays; i++) {
          await addDoc(collection(db, "payhistory"), {
            bookingid: bookingRef.id, customerId: customerRef.id, paymode1, amount1: Number(amount1) / noofdays, paytime1,
            paymode2, amount2: Number(amount2 || 0) / noofdays, paytime2, type: "Booking", paymenttype: "B", status: "Working",
            propertyId, uid: auth.currentUser?.uid, note, createdAt: Timestamp.fromDate(new Date(new Date().setDate(new Date().getDate() + i))),
          });
        }
      }

      for (const room of bookingrooms) {
        await updateDoc(doc(db, "roominfos", room.roomid), { status: "Booked" });
      }

      const roomStr = bookingrooms.map(r => r.roomno).join(', ');
      const inTimeStr = `${moment(checkindate).format('DD-MM-YYYY')} ${checkintime}`;
      const outTimeStr = `${moment(checkoutdate).format('DD-MM-YYYY')} ${checkouttime}`;
      await sendWhatsAppMessage(custname, propertyName, roomStr, totalamount, inTimeStr, outTimeStr, mobile);

      Toast.fire({ icon: "success", title: "Reservation successfully completed" });
      setTimeout(() => window.location.reload(), 1500);
    } catch (error) {
      console.error(error);
      Toast.fire({ icon: "error", title: "Reservation failed", text: error.message });
    } finally {
      setIsLoading(false);
      setOpen(false);
    }
  };

  const getRoomTypeData = (rt) => {
    handleroomtypeChange(rt.roomType.id);
    setroomid(rt.roomInfoId);
  }

  const getBookingSourceStyles = (source) => {
    const normSource = (source || "").toLowerCase().trim();
    if (normSource.includes("booking.com") || normSource.includes("ota") || normSource.includes("expedia")) {
      return { bg: "rgba(14, 165, 233, 0.2)", border: "#0ea5e9", text: "#e0f2fe" };
    }
    if (
      normSource.includes("mmt") ||
      normSource.includes("makemytrip") ||
      normSource.includes("makey my trip") ||
      normSource.includes("goibibo") ||
      normSource.includes("goibibio") ||
      normSource.includes("agoda") ||
      normSource.includes("agpda")
    ) {
      return { bg: "rgba(236, 72, 153, 0.2)", border: "#ec4899", text: "#fce7f3" };
    }
    if (normSource.includes("website") || normSource.includes("direct")) {
      return { bg: "rgba(99, 102, 241, 0.2)", border: "#6366f1", text: "#e0e7ff" };
    }
    if (normSource.includes("walk")) {
      return { bg: "rgba(34, 197, 94, 0.2)", border: "#22c55e", text: "#dcfce7" };
    }
    if (normSource.includes("call") || normSource.includes("phone")) {
      return { bg: "rgba(168, 85, 247, 0.2)", border: "#a855f7", text: "#f3e8ff" };
    }
    if (normSource.includes("agent") || normSource.includes("reference")) {
      return { bg: "rgba(45, 212, 191, 0.2)", border: "#14b8a6", text: "#ccfbf1" };
    }
    return { bg: "rgba(148, 163, 184, 0.2)", border: "#94a3b8", text: "#f1f5f9" };
  };

  const InfoRow = ({ label, value, highlight }) => (
    <Box display="flex" justifyContent="space-between" mb={0.5}>
      <Typography variant="body2" sx={{ color: colors.vanilla, opacity: 0.8 }}>{label}</Typography>
      <Typography variant="body2" fontWeight={highlight ? 700 : 500} color={highlight ? colors.gold : colors.vanilla}>{value}</Typography>
    </Box>
  );

  return (
    <Box display="flex" minHeight="100vh" bgcolor={colors.darkGreen} color={colors.vanilla}>
      <Box  flex={1} p={2} component={motion.div} initial={{ opacity: 0 }} animate={{ opacity: 1 }}>

        {/* HEADER */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography variant="h5" fontWeight={800} sx={{ color: colors.gold }}>RESERVATION</Typography>
          <Box display="flex" alignItems="center" gap={2}>
            <FormControlLabel
              control={
                <Switch 
                  checked={expandAll} 
                  onChange={(e) => setExpandAll(e.target.checked)} 
                  sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                      color: colors.gold,
                      '& + .MuiSwitch-track': {
                        backgroundColor: colors.goldenrod,
                      },
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" fontWeight={600} sx={{ color: colors.vanilla }}>
                  Expand All Rooms
                </Typography>
              }
            />
            <Paper elevation={0} sx={{ borderRadius: 3, display: 'flex', gap: 1, border: `1px solid ${colors.calPolyGreen}`, bgcolor: colors.calPolyGreen, color: colors.vanilla }}>
              <IconButton onClick={() => setPage(page - 1)} sx={{ color: colors.vanilla }}><ArrowBack /></IconButton>
              <Box display="flex" alignItems="center" px={2} fontWeight={600} sx={{ color: colors.vanilla }}>
                {format(visibleDates[0] || new Date(), "dd MMM")} - {format(visibleDates[PAGE_SIZE - 1] || new Date(), "dd MMM yyyy")}
              </Box>
              <IconButton onClick={() => setPage(page + 1)} sx={{ color: colors.vanilla }}><ArrowForward /></IconButton>
            </Paper>
          </Box>
        </Box>

        {/* TIMELINE */}
        <Card sx={{ borderRadius: "16px", boxShadow: "0 10px 32px rgba(0,0,0,0.2)", border: `1px solid ${colors.calPolyGreen}`, bgcolor: colors.calPolyGreen }}>
          <Box sx={{ overflowX: "auto", position: "relative" }}>
            <Box display="flex" sx={{ borderBottom: `1px solid ${colors.darkGreen}`, minWidth: "max-content", bgcolor: colors.darkGreen }}>
              <Box sx={{ minWidth: LEFT_COL_WIDTH, p: 2, borderRight: `1px solid ${colors.calPolyGreen}`, fontWeight: 700, fontSize: "0.75rem", position: "sticky", left: 0, zIndex: 3, bgcolor: colors.darkGreen, color: colors.vanilla }}>ROOM DETAILS</Box>
              {visibleDates.map((d) => (
                <Box key={d.toString()} width={COL_WIDTH} sx={{ p: "12px 8px", textAlign: "center", borderRight: `1px solid ${colors.calPolyGreen}`, bgcolor: [0, 6].includes(d.getDay()) ? colors.calPolyGreen : colors.darkGreen }}>
                  <Typography variant="caption" fontWeight={600} sx={{ color: [0, 6].includes(d.getDay()) ? colors.gold : colors.vanilla, opacity: 0.8, display: "block", fontSize: "10px" }}>{format(d, "EEE").toUpperCase()}</Typography>
                  <Typography variant="h6" fontWeight={700} sx={{ color: [0, 6].includes(d.getDay()) ? colors.gold : colors.vanilla, mt: 0.2, fontSize: "1.05rem" }}>{format(d, "dd")}</Typography>
                </Box>
              ))}
            </Box>
            {roomTypes.map((rt) => (
              <Accordion 
                key={rt.id} 
                expanded={expandAll ? true : expanded === rt.id} 
                onChange={() => {
                  if (!expandAll) {
                    setExpanded(expanded === rt.id ? false : rt.id);
                  }
                }} 
                disableGutters 
                elevation={0} 
                sx={{ bgcolor: colors.calPolyGreen, color: colors.vanilla, borderBottom: `1px solid ${colors.darkGreen}`, "&:before": { display: "none" } }}
              >
                <AccordionSummary sx={{ bgcolor: colors.calPolyGreen, height: "44px", borderBottom: (expandAll || expanded === rt.id) ? `1px solid ${colors.darkGreen}` : "none", color: colors.vanilla }} expandIcon={!expandAll && <ExpandMoreIcon sx={{ fontSize: 18, color: colors.vanilla }} />}>
                  <Typography fontWeight={700} sx={{ fontSize: "0.85rem", color: colors.vanilla }}>{rt.roomTypeName}</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, minWidth: "max-content", bgcolor: colors.darkGreen }}>
                  {(roomNumbers[rt.id] || []).map((room) => (
                    <Box key={room.id} display="flex" sx={{ borderBottom: `1px solid ${colors.calPolyGreen}`, position: "relative" }}>
                      <Box sx={{ minWidth: LEFT_COL_WIDTH, p: "10px 16px", borderRight: `1px solid ${colors.calPolyGreen}`, bgcolor: colors.darkGreen, zIndex: 2, position: "sticky", left: 0, color: colors.vanilla }}>
                        <Typography variant="subtitle2" fontWeight={700} sx={{ color: colors.vanilla }}>Room {room.roomNo}</Typography>
                        <Typography variant="caption" sx={{ color: colors.vanilla, opacity: 0.7, fontSize: "10px" }}>{rt.roomTypeName}</Typography>
                      </Box>
                      {visibleDates.map((d) => {
                        const res = getReservationForCell(room.roomNo, d);
                        const isCheckIn = res && res.checkindate === format(d, "yyyy-MM-dd");

                        return (
                          <Box key={d.toISOString()} width={COL_WIDTH} height={ROW_HEIGHT} sx={{
                            borderRight: `1px solid ${colors.calPolyGreen}`,
                            position: "relative",
                            cursor: res ? "default" : "pointer",
                            transition: "background-color 0.15s",
                            "&:hover": {
                              bgcolor: res ? "transparent" : colors.calPolyGreen
                            }
                          }}
                            onClick={() => {
                              if (res) return;
                              setSelected({ roomType: rt, roomNumber: room.roomNo, roomInfoId: room.id });
                              getRoomTypeData({ roomType: rt, roomNumber: room.roomNo, roomInfoId: room.id });
                              setcheckindate(format(d, "yyyy-MM-dd"));
                              setcheckoutdate(format(addDays(d, 1), "yyyy-MM-dd"));
                              setOpen(true);
                            }}
                          >
                            <AnimatePresence>
                              {isCheckIn && (() => {
                                const theme = getBookingSourceStyles(res.bookingsource);
                                const normalizedSource = res.bookingsource?.toLowerCase() || "";

                                let logoSrc = "";
                                if (normalizedSource.includes("booking")) logoSrc = "/logos/booking.png";
                                else if (normalizedSource.includes("mmt") || normalizedSource.includes("makemytrip") || normalizedSource.includes("makey my trip")) logoSrc = "/logos/mmt.png";
                                else if (normalizedSource.includes("goibibo") || normalizedSource.includes("goibibio")) logoSrc = "/logos/goibibo.png";
                                else if (normalizedSource.includes("agoda") || normalizedSource.includes("agpda")) logoSrc = "/logos/agoda.png";

                                return (
                                  <motion.div
                                    initial={{ y: 6, opacity: 0, scale: 0.96 }}
                                    animate={{ y: 0, opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0, scale: 0.92 }}
                                    transition={{ type: "spring", stiffness: 340, damping: 26 }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate(`/reservation-details/${res.id}`);
                                    }}
                                    whileHover={{
                                      scale: 1.015,
                                      boxShadow: "0 6px 16px rgba(0, 0, 0, 0.4)",
                                      filter: "brightness(1.1)"
                                    }}
                                    style={{
                                      position: "absolute",
                                      top: 2,
                                      left: 2,
                                      height: ROW_HEIGHT,
                                      width: `calc(${differenceInDays(parseISO(res.checkoutdate), parseISO(res.checkindate))} * ${COL_WIDTH}px - 12px)`,
                                      backgroundColor: theme.bg,
                                      color: theme.text,
                                      borderLeft: `4px solid ${theme.border}`,
                                      borderRadius: "8px",
                                      zIndex: 10,
                                      padding: "6px 12px",
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                      cursor: "pointer"
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      fontWeight={800}
                                      sx={{ lineHeight: 1.2, color: theme.text }}
                                    >
                                      {res.customers?.custname?.toUpperCase()}
                                    </Typography>

                                    <Box display="flex" alignItems="center" justifyContent="space-between" mt={0.4} gap={1}>
                                      <Typography variant="caption" sx={{ fontSize: "11px", fontWeight: 600, opacity: 0.9, color: theme.text }}>
                                        ₹ {Number(res.totalamount).toLocaleString("en-IN")}
                                      </Typography>

                                      {logoSrc ? (
                                        <Box component="img" src={logoSrc} alt={res.bookingsource} sx={{ height: 13, objectFit: "contain", borderRadius: "2px", filter: "drop-shadow(0px 1px 2px rgba(0,0,0,0.2))" }} />
                                      ) : (
                                        <Box sx={{ fontSize: "8px", px: 0.8, py: 0.1, borderRadius: "4px", backgroundColor: theme.border, color: "#fff", fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.02em" }}>
                                          {res.bookingsource || "Direct"}
                                        </Box>
                                      )}
                                    </Box>
                                  </motion.div>
                                );
                              })()}
                            </AnimatePresence>
                          </Box>
                        );
                      })}
                    </Box>
                  ))}
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Card>
      </Box>

      {/* BOOKING DIALOG */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="lg" PaperProps={{ sx: { bgcolor: colors.darkGreen, color: colors.vanilla, border: `1px solid ${colors.calPolyGreen}` } }}>
        <DialogTitle sx={{ fontWeight: 800, bgcolor: colors.calPolyGreen, color: colors.vanilla }}>New Booking - Room {selected?.roomNumber}</DialogTitle>
        <DialogContent sx={{ mt: 2, p: 3, position: 'relative', bgcolor: colors.darkGreen }}>
          {isLoading && (
            <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, bgcolor: 'rgba(6,54,45,0.8)', zIndex: 99, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <CircularProgress size={50} sx={{ color: colors.gold }} />
            </Box>
          )}

          <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4, '& .MuiStepLabel-label': { color: colors.vanilla }, '& .Mui-active': { color: colors.gold }, '& .Mui-completed': { color: colors.goldenrod } }}>
            {steps.map(label => <Step key={label}><StepLabel>{label}</StepLabel></Step>)}
          </Stepper>

          {/* STEP 0: ROOM DETAILS */}
          {activeStep === 0 && (
            <Box>
              <div className="row mb-3">
                <div className="col-12 col-md-4 mb-3">
                  <Card variant="outlined" sx={{ borderRadius: 2, bgcolor: colors.calPolyGreen, borderColor: colors.calPolyGreen }}>
                    <CardContent>
                      <Stack spacing={2}>
                        <TextField label="Check-In" type="date" size="small" InputLabelProps={{ shrink: true, style: { color: colors.vanilla } }} value={checkindate} onChange={(e) => { setcheckindate(e.target.value); handleDateChange(e.target.value, checkoutdate); }} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla }, '&:hover fieldset': { borderColor: colors.gold }, '&.Mui-focused fieldset': { borderColor: colors.gold } } }} />
                        <TextField label="Check-Out" type="date" size="small" InputLabelProps={{ shrink: true, style: { color: colors.vanilla } }} value={checkoutdate} onChange={(e) => { setcheckoutdate(e.target.value); handleDateChange(checkindate, e.target.value); }} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla }, '&:hover fieldset': { borderColor: colors.gold }, '&.Mui-focused fieldset': { borderColor: colors.gold } } }} />
                        <TextField label="No of Days" size="small" value={noofdays} InputProps={{ readOnly: true, style: { color: colors.vanilla } }} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } } }} />
                      </Stack>
                    </CardContent>
                  </Card>
                </div>
                <div className="col-12 col-md-4 mb-3">
                  <Card variant="outlined" sx={{ borderRadius: 2, bgcolor: colors.calPolyGreen, borderColor: colors.calPolyGreen }}>
                    <CardContent>
                      <Stack spacing={2}>
                        <TextField label="Check-In Time" size="small" value={checkintime} onChange={e => setcheckintime(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla }, '&:hover fieldset': { borderColor: colors.gold }, '&.Mui-focused fieldset': { borderColor: colors.gold } } }} />
                        <TextField label="Check-Out Time" size="small" value={checkouttime} onChange={e => setcheckouttime(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla }, '&:hover fieldset': { borderColor: colors.gold }, '&.Mui-focused fieldset': { borderColor: colors.gold } } }} />
                      </Stack>
                    </CardContent>
                  </Card>
                </div>
                <div className="col-12 col-md-4 mb-3">
                  <Card variant="outlined" sx={{ borderRadius: 2, bgcolor: colors.calPolyGreen, borderColor: colors.calPolyGreen }}>
                    <CardContent>
                      <Stack spacing={1.5}>
                        {[{ label: "Adults", val: adults, setter: setadults, min: 1 }, { label: "Children", val: childs, setter: setchilds, min: 0 }].map((item) => (
                          <Box key={item.label} display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="body2" fontWeight={600} sx={{ color: colors.vanilla }}>{item.label}</Typography>
                            <Box display="flex" alignItems="center" gap={1}>
                              <IconButton size="small" onClick={() => item.setter(Math.max(item.min, item.val - 1))} sx={{ color: colors.vanilla }}><Remove fontSize="small" /></IconButton>
                              <Typography fontWeight={700} width={20} textAlign="center" sx={{ color: colors.vanilla }}>{item.val}</Typography>
                              <IconButton size="small" onClick={() => item.setter(item.val + 1)} sx={{ color: colors.vanilla }}><Add fontSize="small" /></IconButton>
                            </Box>
                          </Box>
                        ))}
                        <Divider sx={{ borderColor: colors.darkGreen }} />
                        <Box display="flex" justifyContent="space-between"><Typography variant="body2" fontWeight={600} sx={{ color: colors.vanilla }}>Total Rooms Added</Typography><Typography fontWeight={700} sx={{ color: colors.gold }}>{noofrooms}</Typography></Box>
                      </Stack>
                    </CardContent>
                  </Card>
                </div>
              </div>

              <Card variant="outlined" sx={{ borderRadius: 2, bgcolor: colors.calPolyGreen, borderColor: colors.calPolyGreen }}>
                <CardContent>
                  <div className="row align-items-center">
                    <div className="col-12 col-md-3 mb-3">
                      <TextField select label="Room Type" size="small" fullWidth value={rtypeid} onChange={(e) => handleroomtypeChange(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla }, '&:hover fieldset': { borderColor: colors.gold }, '&.Mui-focused fieldset': { borderColor: colors.gold } }, '& .MuiSelect-select': { color: colors.vanilla } }}>
                        {roomTypes.map(item => <MenuItem key={item.id} value={item.id}>{item.roomTypeName}</MenuItem>)}
                      </TextField>
                    </div>
                    <div className="col-12 col-md-2 mb-3">
                      <TextField select label="Room No" size="small" fullWidth value={roomid} onChange={(e) => setroomid(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla }, '&:hover fieldset': { borderColor: colors.gold }, '&.Mui-focused fieldset': { borderColor: colors.gold } }, '& .MuiSelect-select': { color: colors.vanilla } }}>
                        {availableRooms.length === 0 && <MenuItem disabled value="">No rooms available</MenuItem>}
                        {availableRooms.map(item => <MenuItem key={item.id} value={item.id}>{item.data.roomNo}</MenuItem>)}
                      </TextField>
                    </div>
                    <div className="col-12 col-md-2 mb-3">
                      <TextField select label="Plan" size="small" fullWidth value={planid} onChange={(e) => handleplanChange(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla }, '&:hover fieldset': { borderColor: colors.gold }, '&.Mui-focused fieldset': { borderColor: colors.gold } }, '& .MuiSelect-select': { color: colors.vanilla } }}>
                        {plans.map(item => <MenuItem key={item.id} value={item.id}>{item.data.planName}</MenuItem>)}
                      </TextField>
                    </div>
                    <div className="col-12 col-md-2 mb-3">
                      <TextField label="Amount" size="small" fullWidth value={amount} onChange={e => { setamount(e.target.value); setroomrate(e.target.value); }}
                        sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla }, '&:hover fieldset': { borderColor: colors.gold }, '&.Mui-focused fieldset': { borderColor: colors.gold } } }}
                        InputProps={{
                          readOnly: !isAmountUnlocked,
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton size="small" onClick={() => setIsAmountUnlocked(!isAmountUnlocked)} sx={{ color: colors.vanilla }}>
                                {isAmountUnlocked ? <LockOpenOutlined fontSize="small" /> : <LockOutlined fontSize="small" />}
                              </IconButton>
                            </InputAdornment>
                          )
                        }} />
                    </div>
                    <div className="col-12 col-md-2 mb-3">
                      <TextField label="Discount (%)" type="number" size="small" fullWidth value={discount} onChange={e => {
                        let val = Number(e.target.value);
                        if (val > discountupto) { setDiscountError(`Max ${discountupto}%`); setdiscount(discountupto); }
                        else { setDiscountError(""); setdiscount(val); setroomrate((amount - (amount * val) / 100).toFixed(2)); }
                      }} error={!!discountError} helperText={discountError} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla }, '&:hover fieldset': { borderColor: colors.gold }, '&.Mui-focused fieldset': { borderColor: colors.gold } } }} />
                    </div>
                    <div className="col-8 col-md-1 mb-3">
                      <TextField label="Rate" size="small" fullWidth InputProps={{ readOnly: true }} value={roomrate} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } } }} />
                    </div>
                    <div className="col-4 col-md-1 mb-3">
                      <Button fullWidth variant="contained" sx={{ height: 40, bgcolor: colors.gold, color: colors.darkGreen, '&:hover': { bgcolor: colors.goldenrod } }} onClick={handleRoomArray}><Add /></Button>
                    </div>
                  </div>

                  {bookingrooms.map((item, i) => (
                    <div className="row align-items-center mt-2 border-bottom pb-2" key={i} style={{ borderColor: colors.darkGreen }}>
                      <div className="col-12 col-md-2"><Typography variant="body2" sx={{ color: colors.vanilla }}>{item.roomtypename}</Typography></div>
                      <div className="col-12 col-md-2"><Typography variant="body2" fontWeight={700} sx={{ color: colors.gold }}>RM: {item.roomno}</Typography></div>
                      <div className="col-12 col-md-2"><Typography variant="body2" sx={{ color: colors.vanilla }}>{item.planname}</Typography></div>
                      <div className="col-12 col-md-2"><Typography variant="body2" sx={{ color: colors.vanilla }}>₹ {item.amount}</Typography></div>
                      <div className="col-12 col-md-1"><Typography variant="body2" sx={{ color: colors.vanilla }}>{item.discount}%</Typography></div>
                      <div className="col-12 col-md-2"><Typography variant="body2" color="primary" fontWeight={700} sx={{ color: colors.gold }}>₹ {item.roomrate}</Typography></div>
                      <div className="col-12 col-md-1"><IconButton color="error" size="small" onClick={() => removeItem(item)}><Delete fontSize="small" /></IconButton></div>
                    </div>
                  ))}
                </CardContent>
              </Card>
            </Box>
          )}

          {/* STEP 1: CUSTOMER DETAILS */}
          {activeStep === 1 && (
            <Card variant="outlined" sx={{ borderRadius: 2, bgcolor: colors.calPolyGreen, borderColor: colors.calPolyGreen }}>
              <CardContent>
                <div className="row">
                  <div className="col-12 col-md-3 mb-3"><TextField size="small" fullWidth label="Full Name *" value={custname} onChange={e => setcustname(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } } }} /></div>
                  <div className="col-12 col-md-3 mb-3"><TextField size="small" fullWidth label="Mobile *" type="tel" value={mobile} onChange={e => { const v = e.target.value.replace(/\D/g, ''); if (v.length <= 10) setmobile(v); }} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } } }} /></div>
                  <div className="col-12 col-md-3 mb-3"><TextField size="small" fullWidth label="Email" type="email" value={email} onChange={e => setemail(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } } }} /></div>
                  <div className="col-12 col-md-3 mb-3"><TextField size="small" fullWidth label="Address *" value={address} onChange={e => setaddress(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } } }} /></div>
                  <div className="col-12 col-md-3 mb-3"><TextField size="small" fullWidth label="City *" value={city} onChange={e => setcity(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } } }} /></div>
                  <div className="col-12 col-md-3 mb-3">
                    <TextField select size="small" fullWidth label="State" value={state} onChange={e => setstate(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } }, '& .MuiSelect-select': { color: colors.vanilla } }}>
                      <MenuItem value="Maharashtra">Maharashtra</MenuItem>
                      <MenuItem value="Gujarat">Gujarat</MenuItem>
                      <MenuItem value="Karnataka">Karnataka</MenuItem>
                      <MenuItem value="Delhi">Delhi</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </TextField>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <TextField select size="small" fullWidth label="Gender" value={gender} onChange={e => setgender(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } }, '& .MuiSelect-select': { color: colors.vanilla } }}>
                      <MenuItem value="Male">Male</MenuItem><MenuItem value="Female">Female</MenuItem><MenuItem value="Other">Other</MenuItem>
                    </TextField>
                  </div>
                  <div className="col-12 col-md-3 mb-3"><TextField size="small" fullWidth label="Visit Purpose" value={visitpurpose} onChange={e => setvisitpurpose(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } } }} /></div>
                  <div className="col-12 col-md-3 mb-3"><TextField size="small" fullWidth label="Company" value={companydetails} onChange={e => setcompanydetails(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } } }} /></div>
                  <div className="col-12 col-md-3 mb-3">
                    <TextField select size="small" fullWidth label="Booking Source" value={bookingsource} onChange={e => setbookingsource(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } }, '& .MuiSelect-select': { color: colors.vanilla } }}>
                      {bookingtypes.map(item => <MenuItem key={item.id} value={item.data.bookingtype}>{item.data.bookingtype}</MenuItem>)}
                    </TextField>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <TextField select size="small" fullWidth label="Document Type *" value={documenttype} onChange={e => setdocumenttype(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } }, '& .MuiSelect-select': { color: colors.vanilla } }}>
                      {DOCUMENT_TYPES.map(doc => <MenuItem key={doc.value} value={doc.value}>{doc.label}</MenuItem>)}
                    </TextField>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <TextField size="small" fullWidth label="ID Number *" value={idno} onChange={e => {
                      const val = e.target.value.toUpperCase(); setidno(val);
                      if (documenttype && VALIDATION_RULES[documenttype]) {
                        setError(VALIDATION_RULES[documenttype].pattern.test(val) ? '' : VALIDATION_RULES[documenttype].message);
                      }
                    }} disabled={!documenttype} error={!!error} helperText={error} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } } }} />
                  </div>
                  <div className="col-12 col-md-3 mb-3"><TextField size="small" fullWidth label="GST Name" value={gstname} onChange={e => setgstname(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } } }} /></div>
                  <div className="col-12 col-md-3 mb-3"><TextField size="small" fullWidth label="GST No" value={gstno} onChange={e => setgstno(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } } }} /></div>
                </div>

                <Box mt={3} pt={2} borderTop={`1px solid ${colors.darkGreen}`}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="subtitle2" fontWeight={700} sx={{ color: colors.vanilla }}>Additional Guests ({adultsList.length})</Typography>
                    <Button size="small" variant="outlined" onClick={() => setAdultsList([...adultsList, { name: '', mobile: '', email: '', docType: '', idNo: '', gender: 'Male' }])} sx={{ color: colors.gold, borderColor: colors.gold }}>+ Add Guest</Button>
                  </Box>
                  {adultsList.map((adult, index) => (
                    <div className="row align-items-center mb-2" key={index}>
                      <div className="col-12 col-md-3 mb-2"><TextField size="small" fullWidth label="Name" value={adult.name} onChange={e => { let arr = [...adultsList]; arr[index].name = e.target.value; setAdultsList(arr); }} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } } }} /></div>
                      <div className="col-12 col-md-3 mb-2"><TextField size="small" fullWidth label="Mobile" value={adult.mobile} onChange={e => { let arr = [...adultsList]; arr[index].mobile = e.target.value; setAdultsList(arr); }} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } } }} /></div>
                      <div className="col-12 col-md-2 mb-2">
                        <TextField select size="small" fullWidth label="ID Type" value={adult.docType} onChange={e => { let arr = [...adultsList]; arr[index].docType = e.target.value; setAdultsList(arr); }} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } }, '& .MuiSelect-select': { color: colors.vanilla } }}>
                          {DOCUMENT_TYPES.map(doc => <MenuItem key={doc.value} value={doc.value}>{doc.label}</MenuItem>)}
                        </TextField>
                      </div>
                      <div className="col-12 col-md-3 mb-2"><TextField size="small" fullWidth label="ID Number" value={adult.idNo} onChange={e => { let arr = [...adultsList]; arr[index].idNo = e.target.value; setAdultsList(arr); }} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } } }} /></div>
                      <div className="col-12 col-md-1 mb-2"><IconButton color="error" onClick={() => setAdultsList(adultsList.filter((_, i) => i !== index))}><Delete /></IconButton></div>
                    </div>
                  ))}
                </Box>
              </CardContent>
            </Card>
          )}

          {/* STEP 2: DOCUMENTS */}
          {activeStep === 2 && (
            <div className="row">
              {[
                { label: 'Visitor Photo', key: 'visitor' },
                { label: 'ID Front', key: 'idFront' },
                { label: 'ID Back', key: 'idBack' },
                { label: 'Couple Photo', key: 'couple' }
              ].map(cam => (
                <div className="col-12 col-md-3 mb-3" key={cam.key}>
                  <Card variant="outlined" sx={{ borderRadius: 2, textAlign: 'center', p: 2, bgcolor: colors.calPolyGreen, borderColor: colors.calPolyGreen, color: colors.vanilla }}>
                    <Typography variant="subtitle2" mb={1} sx={{ color: colors.vanilla }}>{cam.label}</Typography>
                    {photos[cam.key] ? (
                      <Box>
                        <img src={photos[cam.key]} alt={cam.label} style={{ width: '100%', borderRadius: 8, marginBottom: 8 }} />
                        <Stack direction="row" spacing={1} justifyContent="center">
                          <Button size="small" variant="outlined" onClick={() => setActiveCamera(cam.key)} sx={{ color: colors.vanilla, borderColor: colors.vanilla }}>Retake</Button>
                          <Button size="small" variant="contained" onClick={() => uploadPhoto(cam.key)} disabled={uploadingState[cam.key]} sx={{ bgcolor: colors.gold, color: colors.darkGreen }}>
                            {uploadingState[cam.key] ? <CircularProgress size={16} /> : "Upload"}
                          </Button>
                        </Stack>
                      </Box>
                    ) : (
                      <Box bgcolor={colors.darkGreen} height={120} display="flex" alignItems="center" justifyContent="center" borderRadius={2} border={`1px dashed ${colors.vanilla}`} mb={1}>
                        <IconButton onClick={() => setActiveCamera(cam.key)} sx={{ color: colors.gold }}><CameraAlt fontSize="large" /></IconButton>
                      </Box>
                    )}
                  </Card>
                </div>
              ))}
            </div>
          )}

          {/* STEP 3: PAYMENT & SUMMARY */}
          {activeStep === 3 && (
            <Box>
              <div className="row mb-3">
                <div className="col-12 col-md-4 mb-3">
                  <Card variant="outlined" sx={{ borderRadius: 2, height: '100%', bgcolor: colors.calPolyGreen, borderColor: colors.calPolyGreen, color: colors.vanilla }}>
                    <CardHeader avatar={<Avatar src={photoUrls.visitorUrl || ""} />} title={<Typography fontWeight={700} sx={{ color: colors.vanilla }}>{custname}</Typography>} subheader={<Typography sx={{ color: colors.vanilla, opacity: 0.8 }}>{mobile}</Typography>} sx={{ pb: 0 }} />
                    <CardContent>
                      <InfoRow label="Address" value={`${address}, ${city}`} />
                      <InfoRow label="Check-In" value={`${checkindate} | ${checkintime}`} />
                      <InfoRow label="Check-Out" value={`${checkoutdate} | ${checkouttime}`} />
                      <InfoRow label="Rooms" value={bookingrooms.map(r => r.roomno).join(', ')} />
                    </CardContent>
                  </Card>
                </div>
                <div className="col-12 col-md-8 mb-3">
                  <Card variant="outlined" sx={{ borderRadius: 2, bgcolor: colors.calPolyGreen, borderColor: colors.calPolyGreen, color: colors.vanilla }}>
                    <CardContent>
                      <div className="row">
                        {/* Payment Mode 1 */}
                        <div className="col-12 col-md-6 mb-3">
                          <Typography variant="subtitle2" mb={1} fontWeight={700} sx={{ color: colors.vanilla }}>Payment Mode 1</Typography>
                          <Stack spacing={1.5}>
                            <TextField select size="small" fullWidth label="Mode" value={paymode1} onChange={e => setpaymode1(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } }, '& .MuiSelect-select': { color: colors.vanilla }, bgcolor: colors.darkGreen }}>
                              {paymodes.map(m => <MenuItem key={m.id} value={m.id}>{m.data.paymode}</MenuItem>)}
                            </TextField>
                            <TextField type="number" size="small" fullWidth label="Amount" value={amount1} onChange={handleamount1} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } }, bgcolor: colors.darkGreen }} />
                            <TextField size="small" fullWidth label="Payment Note 1" value={paytime1} onChange={(e) => setpaytime1(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } }, bgcolor: colors.darkGreen }} />
                          </Stack>
                        </div>

                        {/* Payment Mode 2 */}
                        <div className="col-12 col-md-6 mb-3">
                          <Typography variant="subtitle2" mb={1} fontWeight={700} sx={{ color: colors.vanilla }}>Payment Mode 2 (Optional)</Typography>
                          <Stack spacing={1.5}>
                            <TextField select size="small" fullWidth label="Mode" value={paymode2} onChange={e => setpaymode2(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } }, '& .MuiSelect-select': { color: colors.vanilla }, bgcolor: colors.darkGreen }}>
                              {paymodes.map(m => <MenuItem key={m.id} value={m.id}>{m.data.paymode}</MenuItem>)}
                            </TextField>
                            <TextField type="number" size="small" fullWidth label="Amount" value={amount2} onChange={handleamount2} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } }, bgcolor: colors.darkGreen }} />
                            <TextField size="small" fullWidth label="Payment Note 2" value={paytime2} onChange={(e) => setpaytime2(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } }, bgcolor: colors.darkGreen }} />
                          </Stack>
                        </div>

                        {/* Booking Note & Totals */}
                        <div className="col-12">
                          <Divider sx={{ my: 2, borderColor: colors.darkGreen }} />
                          <Box mb={2}>
                            <TextField size="small" fullWidth label="General Booking Note" value={note} onChange={(e) => setnote(e.target.value)} sx={{ input: { color: colors.vanilla }, label: { color: colors.vanilla }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: colors.vanilla } }, bgcolor: colors.darkGreen }} />
                          </Box>

                          <Box display="flex" justifyContent="space-between" px={2}>
                            <Box textAlign="center">
                              <Typography variant="caption" sx={{ color: colors.vanilla, opacity: 0.8 }}>Total</Typography>
                              <Typography variant="h6" fontWeight={800} sx={{ color: colors.gold }}>₹{totalamount}</Typography>
                            </Box>
                            <Box textAlign="center">
                              <Typography variant="caption" sx={{ color: colors.vanilla, opacity: 0.8 }}>Advance</Typography>
                              <Typography variant="h6" fontWeight={800} sx={{ color: '#4ade80' }}>₹{advance}</Typography>
                            </Box>
                            <Box textAlign="center">
                              <Typography variant="caption" sx={{ color: colors.vanilla, opacity: 0.8 }}>Remaining</Typography>
                              <Typography variant="h6" fontWeight={800} sx={{ color: '#f87171' }}>₹{remaining}</Typography>
                            </Box>
                          </Box>
                        </div>

                      </div>
                    </CardContent>
                  </Card>
                </div>
              </div>
            </Box>
          )}

          {/* BOTTOM ACTIONS */}
          <Box display="flex" justifyContent="space-between" mt={3} pt={2} borderTop={`1px solid ${colors.calPolyGreen}`}>
            <Button color="error" onClick={() => setOpen(false)}>Cancel</Button>
            <Box display="flex" gap={2}>
              <Button disabled={activeStep === 0} onClick={handleBack} startIcon={<ArrowBackIosNew fontSize="small" />} sx={{ color: colors.vanilla }}>Back</Button>
              {activeStep === steps.length - 1 ? (
                <Button variant="contained" onClick={checkoutReservation} sx={{ px: 4, fontWeight: 700, bgcolor: '#16a34a', color: '#fff', '&:hover': { bgcolor: '#15803d' } }}>Confirm Booking</Button>
              ) : (
                <Button variant="contained" onClick={handleNext} endIcon={<ArrowForwardIos fontSize="small" />} sx={{ px: 4, fontWeight: 700, bgcolor: colors.gold, color: colors.darkGreen, '&:hover': { bgcolor: colors.goldenrod } }}>Next</Button>
              )}
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* UNIFIED CAMERA DIALOG */}
      <Dialog open={Boolean(activeCamera)} onClose={() => setActiveCamera(null)} maxWidth="sm" fullWidth PaperProps={{ sx: { bgcolor: colors.darkGreen, color: colors.vanilla, border: `1px solid ${colors.calPolyGreen}` } }}>
        <DialogTitle sx={{ fontWeight: 700, bgcolor: colors.calPolyGreen, color: colors.vanilla }}>Capture Image</DialogTitle>
        <DialogContent sx={{ display: 'flex', justifyContent: 'center', p: 2, bgcolor: colors.darkGreen }}>
          {activeCamera && <Webcam audio={false} ref={webcamRef} screenshotFormat="image/jpeg" width="100%" style={{ borderRadius: 8 }} />}
        </DialogContent>
        <DialogActions sx={{ p: 2, bgcolor: colors.darkGreen }}>
          <Button onClick={() => setActiveCamera(null)} sx={{ color: colors.vanilla }}>Cancel</Button>
          <Button variant="contained" onClick={handleCapture} startIcon={<CameraAlt />} sx={{ bgcolor: colors.gold, color: colors.darkGreen, '&:hover': { bgcolor: colors.goldenrod } }}>Capture Now</Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
}